// src/components/Users.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Typography, Box, Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, TextField, Grid, Alert, MenuItem } from '@mui/material';
const API_URL = process.env.REACT_APP_API_URL || '';
const Users = () => {
    const [users, setUsers] = useState([]);
    const [form, setForm] = useState({
        username: '',
        password: '',
        email: '',
        role: '',
        first_name: '',
        last_name: ''
    });
    const [error, setError] = useState('');
    const token = localStorage.getItem('token');

    const fetchUsers = async () => {
        try {
            const response = await axios.get(`${API_URL}/api/users`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setUsers(response.data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [token]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${API_URL}/api/users`, form, {
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchUsers();
            setForm({ username: '', password: '', email: '', role: '', first_name: '', last_name: '' });
            setError('');
        } catch (error) {
            console.error('Error creating user:', error);
            setError('Nie udało się utworzyć użytkownika');
        }
    };

    return (
        <Container maxWidth="lg">
            <Box sx={{ mt: 4 }}>
                <Typography variant="h4" gutterBottom>Użytkownicy</Typography>
                <Paper sx={{ p: 2, mb: 4 }}>
                    <Typography variant="h6">Dodaj nowego użytkownika</Typography>
                    {error && <Alert severity="error">{error}</Alert>}
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Nazwa użytkownika" name="username" value={form.username} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Hasło" name="password" type="password" value={form.password} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Email" name="email" type="email" value={form.email} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Rola"
                                    name="role"
                                    value={form.role}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="admin">Administrator</MenuItem>
                                    <MenuItem value="sales">Sales Department</MenuItem>
                                    <MenuItem value="support">Support Department</MenuItem>
                                    <MenuItem value="development">Development Department</MenuItem>
                                    <MenuItem value="hr">Human Resources</MenuItem>
                                    <MenuItem value="marketing">Marketing Department</MenuItem>
                                </TextField>                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Imię" name="first_name" value={form.first_name} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="Nazwisko" name="last_name" value={form.last_name} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" color="primary">Dodaj użytkownika</Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
                <Paper sx={{ p: 2 }}>
                    <Typography variant="h6" gutterBottom>Lista użytkowników</Typography>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Nazwa użytkownika</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Rola</TableCell>
                                <TableCell>Imię</TableCell>
                                <TableCell>Nazwisko</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users.map(user => (
                                <TableRow key={user.id}>
                                    <TableCell>{user.id}</TableCell>
                                    <TableCell>{user.username}</TableCell>
                                    <TableCell>{user.email}</TableCell>
                                    <TableCell>{user.role}</TableCell>
                                    <TableCell>{user.first_name}</TableCell>
                                    <TableCell>{user.last_name}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            </Box>
        </Container>
    );
};

export default Users;